<ch-breadcrumb [parts]="breadcrumb" (goTo)="(null)"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    Referral Programs
    <a id="referralProgramsListNew" [routerLink]="['/admin/referral-programs/edit']" class="btn btn-default pull-right">
      New
    </a>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">
        No items found.
      </p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Name</span>
            </th>
            <th>
              <span class="col-name">Created At</span>
            </th>
            <th>
              <span class="col-name">Archived At</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index" [class.warning]="item.archivedAt">
            <td class="ab-test-name">
              <span>{{ item.name }}</span>
            </td>
            <td>
              <span>{{ item.createdAt | dateFormat }}</span>
            </td>
            <td>
              <span>{{ (item.archivedAt | dateFormat) || "-" }}</span>
            </td>
            <td class="col-md-1">
              <a class="btn btn-primary" (click)="edit(item)"> Edit </a>
              <a class="btn btn-danger" (click)="delete(item)"> Delete </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/programs/programs-list.component.html